export const blockIconsTextformattingChecklistNew = (
	<span className='material-symbols-outlined'>checklist</span>
);
